
<template>
     <el-menu
        :default-active="activeMenu"
        :unique-opened="true"
      >
        <!-- 导航菜单树组件，动态加载菜单 -->
        <menu-tree-item v-for="item in navTree" :key="item.id" :menu="item"></menu-tree-item>
      </el-menu>
</template>

<script>
import MenuTreeItem from "./MenuTreeItem";

export default {
  name: 'MenuTree',
  props: {
    navTree: {
      type: Array, 
      default: () => [],
    },
  },
  components: { MenuTreeItem },
  computed: {
    // routes() {
    //   return this.$router.options.routes;
    // },
    activeMenu() {
      const { path } = this.$route;
      return path;
    },
  },
};
</script>
